import styled from 'styled-components';
import type { BorderProps } from 'styled-system';
import { border } from 'styled-system';

export const LoadIndicator = styled.div`
  background-color: transparent;
  position: absolute;
  cursor: pointer;
  min-width: 2px;
  height: 4px;
  bottom: 0;
  left: 0;
`;

export const DischargeIndicator = styled.div`
  background-color: transparent;
  position: absolute;
  cursor: pointer;
  min-width: 2px;
  height: 4px;
  bottom: 0;
  right: 0;
`;

export const IndicatorContainer = styled.div`
  position: absolute;
  cursor: pointer;
  min-width: 2px;
  height: 100%;
  display: flex;
  top: 0;
  pointer-events: none;
  overflow: hidden;
`;

export const IndicatorLine = styled.div<BorderProps>(
  {
    borderBottomWidth: '4px',
    boxSizing: 'border-box',
    pointerEvents: 'all',
    minWidth: 0,
  },
  border,
);
export const StaticIndicatorContainer = styled.div`
  cursor: pointer;
  min-width: 2px;
  height: 100%;
  display: flex;
  top: 0;
  pointer-events: none;
  overflow: hidden;
`;
